import styled from "styled-components";

export const CrossIconContainer = styled.button`
  && {
    display: flex;
    border: none;
    position: absolute;
    padding: 0;
    cursor: pointer;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, .6);
    transform: translateX(150%);
    top: -20px;
    right: 49px;

    @media (min-width: 768px) {
      top: 12px;
      right: 12px;
    }

    div {
      padding: 8px;
      border-radius: 50%;
      height: 30px;
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
